import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-459d2a75"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 col-xxl-12 col-sm-12 mb-10" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 mb-4" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, "Retour", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "mb-0" }, "Détails du support de cours", -1))
const _hoisted_9 = { class: "row mb-4" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "info-card p-3 border rounded bg-light" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-primary mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-book me-2" }),
  /*#__PURE__*/_createTextVNode("Informations générales ")
], -1))
const _hoisted_13 = { class: "row mb-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Titre :")
], -1))
const _hoisted_15 = { class: "col-7" }
const _hoisted_16 = { class: "row mb-2" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Description :")
], -1))
const _hoisted_18 = { class: "col-7" }
const _hoisted_19 = { class: "row mb-2" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Auteur :")
], -1))
const _hoisted_21 = { class: "col-7" }
const _hoisted_22 = { class: "row mb-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nombre d'heures :")
], -1))
const _hoisted_24 = { class: "col-7" }
const _hoisted_25 = { class: "row mb-2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Nombre de modules :")
], -1))
const _hoisted_27 = { class: "col-7" }
const _hoisted_28 = { class: "badge bg-success" }
const _hoisted_29 = { class: "row mb-2" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Prérequis :")
], -1))
const _hoisted_31 = { class: "col-7" }
const _hoisted_32 = { class: "row mb-2" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Fichier principal :")
], -1))
const _hoisted_34 = { class: "col-7" }
const _hoisted_35 = {
  key: 0,
  class: "d-flex flex-column gap-2"
}
const _hoisted_36 = { class: "file-name-display mb-2" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-file me-2 text-danger" }, null, -1))
const _hoisted_38 = { class: "text-muted" }
const _hoisted_39 = { class: "d-flex gap-2" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-eye me-1" }, null, -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-download me-1" }, null, -1))
const _hoisted_42 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_43 = { class: "col-md-6" }
const _hoisted_44 = { class: "info-card p-3 border rounded bg-light" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-primary mb-3" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-layers me-2" }),
  /*#__PURE__*/_createTextVNode("Filière / Niveau / Matière ")
], -1))
const _hoisted_46 = { class: "row mb-2" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Filière :")
], -1))
const _hoisted_48 = { class: "col-7" }
const _hoisted_49 = { class: "badge bg-info" }
const _hoisted_50 = { class: "row mb-2" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Niveau :")
], -1))
const _hoisted_52 = { class: "col-7" }
const _hoisted_53 = { class: "badge bg-warning" }
const _hoisted_54 = { class: "row mb-2" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Matière :")
], -1))
const _hoisted_56 = { class: "col-7" }
const _hoisted_57 = { class: "badge bg-primary" }
const _hoisted_58 = { class: "row mb-2" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Date de création :")
], -1))
const _hoisted_60 = { class: "col-7" }
const _hoisted_61 = { class: "row" }
const _hoisted_62 = { class: "col-md-12" }
const _hoisted_63 = { class: "text-primary mb-3 border-bottom pb-2" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-book me-2" }, null, -1))
const _hoisted_65 = { key: 0 }
const _hoisted_66 = { class: "cours-header bg-primary text-white p-2 rounded mb-3" }
const _hoisted_67 = { class: "mb-0" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-book me-2" }, null, -1))
const _hoisted_69 = { class: "row" }
const _hoisted_70 = { class: "col-md-3" }
const _hoisted_71 = { class: "info-item mb-2" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted d-block" }, "Code", -1))
const _hoisted_73 = { class: "col-md-3" }
const _hoisted_74 = { class: "info-item mb-2" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted d-block" }, "Titre", -1))
const _hoisted_76 = { class: "col-md-3" }
const _hoisted_77 = { class: "info-item mb-2" }
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted d-block" }, "Description", -1))
const _hoisted_79 = { class: "col-md-3" }
const _hoisted_80 = { class: "info-item mb-2" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted d-block" }, "Fichier du module", -1))
const _hoisted_82 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_83 = { class: "file-name-display mb-2" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-file me-1 text-danger" }, null, -1))
const _hoisted_85 = { class: "text-muted" }
const _hoisted_86 = { class: "d-flex gap-2" }
const _hoisted_87 = ["onClick"]
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-eye me-1" }, null, -1))
const _hoisted_89 = ["onClick"]
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-download me-1" }, null, -1))
const _hoisted_91 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_92 = {
  key: 1,
  class: "alert alert-info"
}
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-info me-2" }, null, -1))
const _hoisted_94 = { class: "modal-dialog modal-xl modal-dialog-top" }
const _hoisted_95 = { class: "modal-content" }
const _hoisted_96 = { class: "modal-header bg-primary text-white" }
const _hoisted_97 = { class: "modal-title" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-file me-2" }, null, -1))
const _hoisted_99 = { class: "modal-body p-0 pdf-viewer-container" }
const _hoisted_100 = ["src"]
const _hoisted_101 = {
  key: 1,
  class: "d-flex justify-content-center align-items-center",
  style: {"height":"80vh"}
}
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Chargement...")
], -1))
const _hoisted_103 = [
  _hoisted_102
]
const _hoisted_104 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_router_link, {
              to: "/liste-support",
              class: "btn btn-primary transition border-0 lh-1 fw-medium"
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _hoisted_7
              ]),
              _: 1
            }),
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.supportCours?.titre || 'Aucun titre'), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.supportCours?.description || 'Aucune description'), 1)
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.supportCours?.auteur || 'Aucun Auteur'), 1)
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.supportCours?.nombreHeures || 0) + " h", 1)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.supportCours?.modules?.length || 0), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.supportCours?.prerequis || 'Aucun'), 1)
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("div", _hoisted_34, [
                    (_ctx.supportCours?.fichier)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _hoisted_37,
                            _createElementVNode("small", _hoisted_38, _toDisplayString(_ctx.supportCours.fichier), 1)
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("button", {
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.viewSupportFile(_ctx.supportCours.id))),
                              class: "btn btn-sm btn-outline-primary"
                            }, [
                              _hoisted_40,
                              _createTextVNode("Voir ")
                            ]),
                            _createElementVNode("button", {
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.downloadSupportFile(_ctx.supportCours.id, _ctx.supportCours.titre))),
                              class: "btn btn-sm btn-outline-success"
                            }, [
                              _hoisted_41,
                              _createTextVNode("Télécharger ")
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_42, "Aucun fichier"))
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_43, [
              _createElementVNode("div", _hoisted_44, [
                _hoisted_45,
                _createElementVNode("div", _hoisted_46, [
                  _hoisted_47,
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.supportCours?.filiereNiveauMatiere?.filiere?.libelle || 'N/A'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  _hoisted_51,
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.supportCours?.filiereNiveauMatiere?.niveau?.libelle || 'N/A'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _hoisted_55,
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.supportCours?.filiereNiveauMatiere?.matiere?.libelle || 'N/A'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_58, [
                  _hoisted_59,
                  _createElementVNode("div", _hoisted_60, _toDisplayString(_ctx.formatDate(_ctx.supportCours?.createdAt)), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("h5", _hoisted_63, [
                _hoisted_64,
                _createTextVNode("Liste des modules (" + _toDisplayString(_ctx.supportCours?.modules?.length || 0) + ") ", 1)
              ]),
              (_ctx.supportCours?.modules && _ctx.supportCours.modules.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supportCours.modules, (module, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: module.id,
                        class: "cours-card border rounded p-3 mb-3 shadow-sm bg-white"
                      }, [
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("h6", _hoisted_67, [
                            _hoisted_68,
                            _createTextVNode("Module " + _toDisplayString(index + 1) + " : " + _toDisplayString(module.titre), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_69, [
                          _createElementVNode("div", _hoisted_70, [
                            _createElementVNode("div", _hoisted_71, [
                              _hoisted_72,
                              _createElementVNode("strong", null, _toDisplayString(module.code || 'Sans code'), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("div", _hoisted_74, [
                              _hoisted_75,
                              _createElementVNode("strong", null, _toDisplayString(module.titre || 'Aucun titre'), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_76, [
                            _createElementVNode("div", _hoisted_77, [
                              _hoisted_78,
                              _createElementVNode("strong", null, _toDisplayString(module.description || 'Aucune description'), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_79, [
                            _createElementVNode("div", _hoisted_80, [
                              _hoisted_81,
                              (module.fichier)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                    _createElementVNode("div", _hoisted_83, [
                                      _hoisted_84,
                                      _createElementVNode("small", _hoisted_85, _toDisplayString(module.fichier), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_86, [
                                      _createElementVNode("button", {
                                        onClick: ($event: any) => (_ctx.viewModuleFile(module.id)),
                                        class: "btn btn-sm btn-outline-primary"
                                      }, [
                                        _hoisted_88,
                                        _createTextVNode("Voir ")
                                      ], 8, _hoisted_87),
                                      _createElementVNode("button", {
                                        onClick: ($event: any) => (_ctx.downloadModuleFile(module.id, module.titre || module.code)),
                                        class: "btn btn-sm btn-outline-success"
                                      }, [
                                        _hoisted_90,
                                        _createTextVNode("Télécharger ")
                                      ], 8, _hoisted_89)
                                    ])
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_91, "Aucun fichier"))
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_92, [
                    _hoisted_93,
                    _createTextVNode(" Aucun module trouvé pour ce support de cours. ")
                  ]))
            ])
          ])
        ])
      ])
    ]),
    (_ctx.showPdfModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "modal fade show d-block pdf-modal-overlay",
          tabindex: "-1",
          onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closePdfModal && _ctx.closePdfModal(...args)), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_94, [
            _createElementVNode("div", _hoisted_95, [
              _createElementVNode("div", _hoisted_96, [
                _createElementVNode("h5", _hoisted_97, [
                  _hoisted_98,
                  _createTextVNode(_toDisplayString(_ctx.currentPdfTitle), 1)
                ]),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close btn-close-white",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closePdfModal && _ctx.closePdfModal(...args)))
                })
              ]),
              _createElementVNode("div", _hoisted_99, [
                (_ctx.currentPdfBlob)
                  ? (_openBlock(), _createElementBlock("iframe", {
                      key: 0,
                      src: _ctx.currentPdfBlob,
                      class: "pdf-viewer-iframe",
                      title: "Visualiseur PDF"
                    }, null, 8, _hoisted_100))
                  : (_openBlock(), _createElementBlock("div", _hoisted_101, _hoisted_103))
              ]),
              _createElementVNode("div", _hoisted_104, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-secondary",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closePdfModal && _ctx.closePdfModal(...args)))
                }, " Fermer ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}